import { useMemo } from 'react';

const useOptions = (messages) => {

  const optionsTimeMetric = useMemo(() => [{
    id: `today`,
    name: `${messages['dashboardPanel_edit_today']}`
  }, {
    id: `yesterday`,
    name: `${messages['dashboardPanel_edit_yesterday']}`
  }, {
    id: `thisWeek`,
    name: `${messages['dashboardPanel_edit_this_week']}`
  }, {
    id: `thisMonth`,
    name: `${messages['dashboardPanel_edit_this_month']}`
  }], [messages]);

  const optionsFrequency = useMemo(() => [{
    id: 300,
    name: `5 ${messages['dashboardPanel_edit_minutes']}`
  }, {
    id: 900,
    name: `15 ${messages['dashboardPanel_edit_minutes']}`
  }, {
    id: 1800,
    name: `30 ${messages['dashboardPanel_edit_minutes']}`
  },
  {
    id: 3600,
    name: `1 ${messages['dashboardPanel_edit_hours']}`
  },
  {
    id: 7200,
    name: `2 ${messages['hours']}`
  }], [messages]);

  const entities = useMemo(() => [
    { id: "Landmark", label: messages['alertsNewAlert_Landmark_name'] || "Landmark" },
    { id: "All", label: messages['alertsNewAlert_Landmark_all'] || "All" },
  ], [messages]);

  const parameterOrder = useMemo(() => [
    { id: "landmark.landmarkName_asc", name: messages['dashboardPanel_landmark_name_asc'] },
    { id: "landmark.landmarkName_desc", name: messages['dashboardPanel_landmark_name_desc'] },
    { id: "visits_asc", name: messages['dashboardPanel_number_visits_asc'] },
    { id: "visits_desc", name: messages['dashboardPanel_number_visits_desc'] },
    { id: "totalTime_asc", name: messages['dashboardPanel_total_time_asc'] },
    { id: "totalTime_desc", name: messages['dashboardPanel_total_time_desc'] },
  ], [messages]);

  return { optionsTimeMetric, optionsFrequency, entities, parameterOrder };
};

export default useOptions;
